module.exports = __webpack_public_path__ + "img/vi.69e12f7c.png";